module.exports = __webpack_public_path__ + "static/media/SM.9e00ec8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SM.svg
// module id = 361
// module chunks = 0